import { Box, styled, alpha } from '@mui/material';

interface StyledBoxProps {
  showBcArrow?: boolean;
}

const StyledBox = styled(Box)<StyledBoxProps>(
  ({ theme, showBcArrow }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    lineHeight: theme.typography.pxToRem(13),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: '500',
    textTransform: 'uppercase',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      overflowX: 'hidden',
      padding: theme.spacing(1.75, 0),
    },

    '& .BCLinksCon': {
      paddingTop: 0,
      paddingBottom: 0,
      [theme.breakpoints.down('lg')]: {
        display: 'flex',
        flexFlow: 'row',
        alignItems: 'center',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        transition: 'all .6s',
        paddingLeft: showBcArrow ? theme.typography.pxToRem(16)  : 0,
      },
    },

    '& .BCNav': {
      height: theme.spacing(4.5),
      width: theme.spacing(4.5),
      backdropFilter: `blur(${theme.spacing(1)})`,
      borderRadius: '50%',
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      left: 0,
      top: 0,
      bottom: 0,
      margin: 'auto',
      zIndex: '2',
      backgroundColor: theme.palette.secondary.main,
      border: `1px solid ${theme.palette.divider[4]}`,
       boxShadow:`10px -1px 3px 0px   ${alpha(theme.palette.background.default, 0.8)} `,
      [theme.breakpoints.up('lg')]: {
        display: 'none',
      },
    },

    '& .BCArrow': {
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(20),
      '&.rotated': {
        transform: 'rotate(180deg)',
        transition: 'all 0.6s',
      },
    },

    '& .BCListItem': {
      padding: 0,
      [theme.breakpoints.up('lg')]: {
        display: 'inline',
      },
    },

    '& .BCLink': {
      cursor: 'pointer',
      textDecoration: 'none',
      color: theme.palette.text.secondary ,
    },


    '& .BCText': {
      color: theme.palette.grey[200],
      fontWeight: '500',
      fontSize: theme.typography.pxToRem(12),
    },
  
  }),
);
export default StyledBox;
